<script>
import utils from '@/utils/common';
import BaseDatepicker from '@/components/BaseDatepicker.vue';

export default {
  name: 'GanttTermSelector',
  components: { BaseDatepicker },
  props: {
    dateStart: Date,
    dateFinish: Date,
    dateType: String,
  },
  computed: {
    count() {
      if (this.dateStart > this.dateFinish) return 0;

      const start = new Date(this.dateStart.getFullYear(), this.dateStart.getMonth(), this.dateStart.getDate()); // eslint-disable-line max-len
      const finish = new Date(this.dateFinish.getFullYear(), this.dateFinish.getMonth(), this.dateFinish.getDate()); // eslint-disable-line max-len
      let count = 0;

      while (finish >= start) {
        if (![0, 6].includes(start.getDay())) {
          count += 1;
        }

        start.setDate(start.getDate() + 1);
      }

      return count;
    },
    daysStr() {
      return utils.pluralWordPure(this.count, 'день', 'дня', 'дней');
    },
  },
  methods: {
    convertDateToString(date) {
      return utils.convertDateToString(date, 'short', true, false);
    },
    inc() {
      this.$emit('change', [0, 24 * 3600 * 1000]);
    },
    dec() {
      if (this.count <= 1) return;
      this.$emit('change', [0, -24 * 3600 * 1000]);
    },
    startChanged(date) {
      const diff = date - this.dateStart;
      this.$emit('change', [diff, 0]);
    },
    finishChanged(date) {
      const diff = date - this.dateFinish;
      this.$emit('change', [0, diff]);
    },
    changeCount(count) {
      count = +count; // eslint-disable-line
      if (!count) return;
      count = Math.max(1, count); // eslint-disable-line
      count = Math.min(1000, count); // eslint-disable-line
      let diff = count - this.count;

      const refDate = new Date(this.dateFinish);
      const delta = diff / Math.abs(diff);

      while (diff !== 0) {
        refDate.setDate(refDate.getDate() + delta);

        if (![0, 6].includes(refDate.getDay())) {
          diff -= delta;
        }
      }

      this.finishChanged(refDate);
    },
  },
};
</script>

<template lang="pug">
  .gantt-term-selector
    .date(@click="$refs.start.open()") Старт
      br
      b {{ convertDateToString(dateStart) }}
    .middle
      button.dec(@click="dec")
      div
        input(type="text" :value="count" @change="changeCount($event.target.value)")
        | {{ ' ' }} {{ daysStr }}
      button.inc(@click="inc")
    .date(@click="$refs.finish.open()") Финиш
      br
      b {{ convertDateToString(dateFinish) }}
    BaseDatepicker.datepicker.finish(
      :type="dateType",
      @input="finishChanged"
      :value="dateFinish"
      hidden
      ref="finish"
    )
    BaseDatepicker.datepicker.start(
      :type="dateType",
      @input="startChanged"
      :value="dateStart"
      hidden
      ref="start"
    )
</template>

<style scoped lang="scss">
.gantt-term-selector {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  font-size: 12px;
  line-height: 1.5;
  color: #FFFFFF;
  gap: 5px;
  padding: 8px 13px;
  width: auto !important;
  position: relative;
  bottom: 123px;
  left: -50%;
}

.date {
  font-weight: 400;
  font-size: 10px;
  white-space: nowrap;
  cursor: pointer;

  b {
    font-size: 12px;
    font-weight: 500;
  }
}

.middle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #FFFFFF;
  border-bottom: 1px solid #FFFFFF;
  padding: 10px 0;

  input {
    background: transparent;
    font-size: 12px;
    line-height: 1.5;
    color: #FFFFFF;
    width: 20px;
    text-align: center;
  }

  .inc, .dec {
    width: 10px;
    height: 10px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    cursor: pointer;

    &:before, &:after {
      display: block;
      content: '';
      height: 2px;
      width: 10px;
      background: #33A1FB;
    }
  }

  .inc:after {
    position: absolute;
    transform: rotate(90deg);
  }

  .dec:after {
    display: none;
  }
}

.datepicker {
  position: absolute;
  bottom: 0;
  left: 0;
}
</style>
